import type { ReactNode, Ref } from 'react'
import { cn } from '@/lib/utils'

interface PortalSectionProps {
  title: string
  hint?: string
  hintVariant?: 'default' | 'warn'
  children: ReactNode
  id?: string
  /** Form reference number shown before the title in mono, e.g. "02". */
  number?: string
  /** Makes the heading a programmatic focus target (tabIndex -1) for step navigation. */
  headingRef?: Ref<HTMLHeadingElement>
}

export function PortalSection({
  title,
  hint,
  hintVariant = 'default',
  children,
  id,
  number,
  headingRef,
}: PortalSectionProps) {
  return (
    <section className="prod-section prod-section--stacked" id={id}>
      <header className="prod-section__header">
        <h2 ref={headingRef} className="prod-section__title" tabIndex={headingRef ? -1 : undefined}>
          {number ? (
            <span className="prod-section__num" aria-hidden="true">
              {number}
            </span>
          ) : null}
          {title}
        </h2>
        {hint ? (
          <p
            className={cn(
              'prod-section__hint',
              hintVariant === 'warn' && 'prod-section__hint--warn',
            )}
          >
            {hint}
          </p>
        ) : null}
      </header>
      <div className="prod-section__grid">{children}</div>
    </section>
  )
}
